<ion-list *ngIf="fulfillments?.length">
	<ion-radio-group (ionChange)="handleSelection($any($event.target).value)" [value]="defaultFulfillment">
		<ion-item *ngFor="let fulfillment of fulfillments">
			<ion-radio [value]="fulfillment" justify="space-between">
				{{ getContentsLabel(fulfillment) }}
			</ion-radio>
		</ion-item>
	</ion-radio-group>
</ion-list>
